<ion-content>
  <app-global-page-header
    [title]="'functions.filtration.usagemode.title' | translate"
  >
    <div slot="end">
      <ion-button
        color="medium"
        fill="clear"
        shape="round"
        (click)="dismissModal()"
      >
        <i class="fa-solid fa-times"></i>
      </ion-button>
    </div>
  </app-global-page-header>

  <div class="p-4">
    <p
      class="my-2 mb-4 color-medium"
      [innerHTML]="
        brandOverride('P00037.installation.polarite.ensavoirplus' | translate)
          | nl2Br
      "
    ></p>

    <div>
      <table
        class="table table-bordered"
        style="width: 100%; border-width: 2px !important"
      >
        <tr>
          <th class="fw-normal p-1 color-medium">
            {{ 'P00037.installation.inversion.tab.durete' | translate }}
          </th>
          <th class="fw-bold p-1 color-medium">
            {{
              'P00037.installation.inversion.tab.inversionPolarite' | translate
            }}
          </th>
        </tr>
        <tr>
          <td class="p-1 color-medium">
            {{ '< 45' }}
          </td>
          <td class="p-1 color-medium">
            4 {{ 'P00037.installation.inversion.tab.choix' | translate }}
          </td>
        </tr>
        <tr>
          <td class="p-1 color-medium">
            {{ '< 30' }}
          </td>
          <td class="p-1 color-medium">8</td>
        </tr>
        <tr>
          <td class="p-1 color-medium">
            {{ '< 15' }}
          </td>
          <td class="p-1 color-medium">12</td>
        </tr>
        <tr>
          <td class="p-1 color-medium">
            {{ '< 8' }}
          </td>
          <td class="p-1 color-medium">24</td>
        </tr>
      </table>
    </div>

    <p
      class="my-2 mb-4 color-medium"
      [innerHTML]="
        'P00037.installation.polarite.ensavoirplus1' | translate | nl2Br
      "
    ></p>
  </div>
</ion-content>
